import { useContext } from "react"

import { PageContext, PageContextType } from "../contexts/pageState"

const usePageContext = () => useContext<PageContextType>(PageContext)

export default usePageContext
